module.exports = __webpack_public_path__ + "img/Tatsuya_Harada@2x.699045e9.png";